<template>
    <div class="app-container">
      <BjPage ref="BjPage" :query-params="queryParams" :row-style="rowStyleFun" :col-span="colSpan" :label-width="'100px'" :search-btn-span="colSpan" :default-sort="defaultSort" :get-action="queryApi" :serial="serial" :before-reset-search="beforeResetSearch" :tooltip-config="{ contentMethod: false, enterable: true }" @sort-change="sortChange" :selection="selection" @handleSelectionChange="handleSelectionChange" @showSetting="SortableTable.show" @header-dragend="SortableTable.handleHeaderDragend" @header-contextmenu="SortableTable.handleHeaderContextmenu" @afterFetchOriginalData="afterFetchOriginalData">
        <template v-slot:baseForm>
          <!-- 客户名称 -->
          <el-col :span="colSpan">
            <el-form-item :label="$t('billingPage.CustomerName')" prop="cusId">
              <BjSelectLov v-model="queryParams.cusId" :option-list="customerList" :placeholder="$t('customerNameText')" />
            </el-form-item>
          </el-col>
          <el-col :span="colSpan">
            <el-form-item :label="$t('AccountManagement.customer.companyName')" prop="companyName">
              <BjInput v-model="queryParams.companyName" :placeholder="$t('AccountManagement.customer.companyName')" comma @keyup.enter.native="handleQuery" />
            </el-form-item>
          </el-col>
          <!-- 工单编号 -->
          <el-col :span="colSpan">
            <el-form-item :label="$t('workOrderList.Number')" prop="workNo">
              <BjInput v-model="queryParams.workNo" :placeholder="$t('workOrderList.Number')" comma @keyup.enter.native="handleQuery" />
            </el-form-item>
          </el-col>
          <!-- 部门 -->
          <el-col :span="colSpan">
            <el-form-item :label="$t('WorkorderType.table.InquiryType')" prop="consultNameList">
              <BjSelectLov v-model="queryParams.consultNameList" :option-list="consultNameList" multiple :placeholder="$t('WorkorderType.table.InquiryType')"/>
            </el-form-item>
          </el-col>
          <!-- 服务 -->
          <!-- <el-col :span="colSpan">
            <el-form-item :label="$t('workOrderList.service')" prop="workOrderTypeId">
              <BjSelectLov :disabled="!queryParams.consultType" v-model="queryParams.workOrderTypeId" :placeholder="$t('workOrderList.service')" :option-list="workOrderTypeIdList"/>
            </el-form-item>
          </el-col> -->
          <!-- 客服 -->
          <el-col :span="colSpan">
            <el-form-item :label="$t('workOrderList.Customer')" prop="customer">
              <BjSelectLov v-model="queryParams.customer" :option-list="customerNameList" :placeholder="$t('workOrderList.Customer')"/>
            </el-form-item>
          </el-col>
          <!-- 处理部门 -->
          <!-- <el-col :span="colSpan">
            <el-form-item :label="$t('table.Operations')" prop="operationDepartment">
              <BjSelectLov v-model="queryParams.operationDepartment" :option-list="operationList" :placeholder="$t('workOrderList.Operations')" @change="getUserIdList"/>
            </el-form-item>
          </el-col> -->
          <!-- 操作人 -->
          <el-col :span="colSpan">
            <el-form-item :label="$t('table.Operator')" prop="userId">
              <BjSelectLov v-model="queryParams.userId" :option-list="userIdNameList" :placeholder="$t('workOrderList.Operator')"/>
            </el-form-item>
          </el-col>
          <!-- 创建时间 -->
          <el-col :span="colSpan">
            <el-form-item :label="$t('table.createTimeText')">
              <BjDateRangePicker v-model="queryParams_createTime" :placeholder="$t('table.createTimeText')" />
            </el-form-item>
          </el-col>
          <!-- 完成时间 -->
          <el-col :span="colSpan">
            <el-form-item :label="$t('workOrderList.Completion')">
              <BjDateRangePicker v-model="queryParams_endTime" :placeholder="$t('workOrderList.Completion')" />
            </el-form-item>
          </el-col>

          <!-- 工单标题 -->
          <!-- <el-col :span="colSpan">
            <el-form-item :label="$t('workOrderList.WOTitle')" prop="title">
              <BjInput v-model="queryParams.title" :placeholder="$t('workOrderList.WOTitle')" comma @keyup.enter.native="handleQuery" />
            </el-form-item>
          </el-col> -->
          <!-- 紧急程度 -->
          <!-- <el-col :span="colSpan">
            <el-form-item :label="$t('workOrderList.Urgent')" prop="exigency">
              <BjSelectLov v-model="queryParams.exigency" :placeholder="$t('workOrderList.Urgent')" :option-list="CSG_WORK_ORDER_EXIGENCY"/>
            </el-form-item>
          </el-col> -->
        </template>
        <template v-slot:beforeSearchBtn v-if="!closeType">
          <el-col :span="24 - colSpan">
            <el-tabs :value="tabIndex" type="card" @tab-click="handleTabClick">
              <el-tab-pane v-for="(item, index) in CSG_WORK_ORDER_LIST_ADMIN_OPEN" :key="index" :label="$t(item.label)" :name="item.value" />
            </el-tabs>
          </el-col>
        </template>
        <template v-slot:beforeSearchBtn v-else>
          <el-col :span="24 - colSpan">
            <el-tabs :value="tabIndex" type="card" @tab-click="handleTabClick">
              <el-tab-pane v-for="(item, index) in CSG_WORK_ORDER_LIST_ADMIN_CLOSE" :key="index" :label="$t(item.label)" :name="item.value" />
            </el-tabs>
          </el-col>
        </template>
        <template v-slot:tableOperation>
          <el-col>
            <el-button type="primary" @click="onAdd">{{ $t('addText') }}</el-button>
            <BjFrontendExport
              type="primary"
              :label-list="exportLabelList"
              :rows="selectedRows"
              file-name="workOrders.csv"
            />
          </el-col>
        </template>
        <template v-slot:tableColumn>
          <template v-for="(col, index) in dropCols">
            <el-table-column
              v-if="col.prop !== 'bjTableAction'"
              :key="`col_${index}_${col.prop}_${col.width || 'auto'}`"
              :prop="col.prop"
              :label="col.label"
              :width="col.width || 'auto'"
              :fixed="col.fixed || false"
              align="center"
              class-name="item"
            >
              <template slot-scope="scope">
                <template v-if="false" />
                <template v-else-if="col.prop == 'cusId'">{{ customerList.bjGet(scope.row.cusId) }}</template>
                <template v-else-if="col.prop === 'outerOrderNo'">
                  <span>{{ scope.row.webReference }}</span>
                  <BjCopyIcon :copy="scope.row.webReference" />
                </template>
                <template v-else-if="col.prop === 'exigency'">
                  <el-tag v-if="scope.row.exigency">{{ scope.row[col.prop] ? $t(CSG_WORK_ORDER_EXIGENCY.bjGet(scope.row[col.prop])) : '' }}</el-tag>
                </template>
                <template v-else-if="col.prop === 'status'">
                  <el-tag>{{ $t(CSG_WORK_ORDER_STATUS_ADMIN.bjGet(scope.row[col.prop])) }}</el-tag>
                </template>
                <template v-else-if="col.prop === 'pause'">
                  <el-tag v-if="scope.row.pause">{{ scope.row[col.prop] ? $t(CSG_WORK_ORDER_PAUSE.bjGet(scope.row[col.prop])) : '' }}</el-tag>
                </template>
                <span v-else>{{ scope.row[col.prop] | timeFilters(scope.row[col.prop]) }}</span>
              </template>
            </el-table-column>

            <el-table-column v-if="col.prop === 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || 'right'" align="center">
              <template slot-scope="props">
                <el-button type="text" class="edit-btn" @click="onView(props.row)">{{ $t('viewText') }}</el-button>
                <el-dropdown :disabled="props.row.status==7" v-hasDropdownChildren @command="command($event, props.row)">
                  <span class="el-dropdown-link">{{ $t('AccountManagement.common.operate') }}<i class="el-icon-arrow-down el-icon--right" /></span>
                  <el-dropdown-menu slot="dropdown">
                    <!--  status： 1,草稿,2,待审批,3,待处理,4,处理中,5,已处理,6,审批不通过,7,已作废,8,逻辑删除,9,待确认 -->
                    <el-dropdown-item v-if="[1,2,6].includes(props.row.status)" command="edit">{{ $t('editText') }} </el-dropdown-item>
                    <el-dropdown-item v-if="[1].includes(props.row.status)" command="delete"> {{ $t('delText') }} </el-dropdown-item>
                    <el-dropdown-item v-if="[1,6].includes(props.row.status)" command="submit"> {{ $t('workOrderList.WOSubmit') }} </el-dropdown-item>
                    <el-dropdown-item v-permission:BusinessWorkOrderAudit v-if="props.row.status==2 && $store.getters.userInfo.deptAbbr.includes(props.row.operationDepartment)" command="approval"> {{ $t('workOrderList.Approval') }} </el-dropdown-item>
                    <el-dropdown-item v-if="(props.row.status==3 || (props.row.status==4&&props.row.pause==1)) && $store.getters.userInfo.id==props.row.userId" command="start"> {{ $t('workOrderList.Start') }} </el-dropdown-item>
                    <el-dropdown-item v-if="props.row.status==4 && props.row.pause==0 && $store.getters.userInfo.id==props.row.userId" command="stop"> {{ $t('workOrderList.Pause') }} </el-dropdown-item>
                    <el-dropdown-item v-if="props.row.status==4 && props.row.pause==0 && $store.getters.userInfo.id==props.row.userId" command="completed"> {{ $t('workOrderList.Complete') }} </el-dropdown-item>
                    <el-dropdown-item v-permission:BusinessWorkOrderConfirmCharges v-if="[5,9].includes(props.row.status)" command="hoursDone"> {{ $t('workOrderList.Confirm') }} </el-dropdown-item>
                    <el-dropdown-item v-permission:BusinessWorkOrderAudit v-if="props.row.status==3 && $store.getters.userInfo.deptAbbr.includes(props.row.operationDepartment)" command="processor"> {{ $t('workOrderList.processor') }} </el-dropdown-item>
                    <el-dropdown-item v-if="[2,3,6].includes(props.row.status)" command="invalid"> {{ $t('workOrderList.to') }} </el-dropdown-item>
                    <el-dropdown-item v-if="[3,4].includes(props.row.status)" command="endTimeEdit">{{$t('workOrderList.editTime') }}</el-dropdown-item>
                    <!-- 只做admin端、不需要根据状态显示、做按钮权限控制 -->
                    <el-dropdown-item v-permission:BusinessWorkOrderModify command="customerEdit">{{ $t('workOrderList.Modify') }}</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </template>
            </el-table-column>
          </template>
        </template>
      </BjPage>
      <el-dialog
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :title="$t('workOrderList.processor')"
        :visible.sync="addDialogVisible"
        width="500px"
        :before-close="handleClose"
      >
        <el-form ref="form" :model="form" :rules="rules" label-width="100px">
          <el-form-item :label="$t('workOrderList.Operator')" prop="userId">
            <BjSelectLov v-model="form.userId" :option-list="userRoleList" @change="logSome" :placeholder="$t('workOrderList.Operator')"/>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="handleClose('form')">{{ $t('cancelText') }}</el-button>
          <el-button type="primary" @click="submitForm('form')">{{ $t('okText') }}</el-button>
        </span>
      </el-dialog>
      <!-- 修改 客服 -->
      <el-dialog
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :title="$t('workOrderList.Modify')"
        :visible.sync="addDialogVisibl2"
        width="500px"
        :before-close="handleClose"
      >
        <el-form ref="form2" :model="form2" :rules="rules2" label-width="100px">
          <el-form-item :label="$t('workOrderList.Customer')" prop="customer">
            <BjSelectLov v-model="form2.customer" :option-list="customerNameList" :placeholder="$t('workOrderList.Customer')"/>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="handleClose('form2')">{{ $t('cancelText') }}</el-button>
          <el-button type="primary" @click="editWorkerCustomer('form2')">{{ $t('okText') }}</el-button>
        </span>
      </el-dialog>
      <!-- 修改 预计完成时间 -->
      <el-dialog
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :title="$t('workOrderList.editTime')"
        :visible.sync="addDialogVisibl3"
        width="500px"
        :before-close="handleClose"
      >
        <el-form ref="form3" :model="form3" :rules="rules3" label-width="165px">
          <el-form-item :label="$t('workOrderList.editTime')" prop="auditTime">
            <BjDateRangePicker v-model="form3_endTime" :picker-options="pickerOptions" :placeholder="$t('workOrderList.editTime')" />
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="handleClose('form3')">{{ $t('cancelText') }}</el-button>
          <el-button type="primary" @click="editWorkerEndTime('form3')">{{ $t('okText') }}</el-button>
        </span>
      </el-dialog>
    </div>
  </template>
  <script>
  import pageMiXin from '@/utils/page-mixin.js';
  import { workorderApi,userApi } from '@/api';
  import {
    CSG_WORK_ORDER_LIST_ADMIN_OPEN,
    CSG_WORK_ORDER_LIST_ADMIN_CLOSE,
    CSG_WORK_ORDER_STATUS_ADMIN,
    CSG_WORK_ORDER_PAUSE,
    CSG_WORK_ORDER_EXIGENCY,
  } from '@/utils/constants';
  import BjSelectCustomer from '@/components/BjSelectCustomer/index.vue';
  import moment from 'moment';
  
  export default {
    name: 'BusinessWorkorderListAdmin',
    components: { BjSelectCustomer },
    mixins: [pageMiXin],
    props: {
      closeType: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        selection: true,
        colSpan: 4,
        addDialogVisible: false,
        addDialogVisibl2: false,
        addDialogVisibl3: false,
        // 表单校验
        rules: {
          userId: [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
        },
        rules2: {
          customer: [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
        },
        form:{
          id:null,
          workNo:null,
          userId:null,
          userName:null,
        },
        form2:{
          id:null,
          workNo:null,
          customer:null,
        },
        form3_endTime: [],
        form3:{
          id:null,
          workNo:null,
          scheduledStartTime:null,
          scheduledEndTime:null,
        },
        CSG_WORK_ORDER_LIST_ADMIN_OPEN,
        CSG_WORK_ORDER_LIST_ADMIN_CLOSE,
        CSG_WORK_ORDER_STATUS_ADMIN,
        CSG_WORK_ORDER_PAUSE,
        CSG_WORK_ORDER_EXIGENCY,
        queryApi: workorderApi.getWorkOrderPageList,
        // 查询参数
        queryParams_createTime: [],
        queryParams_endTime: [],
        queryParams: {
          cusId: null,
          consultNameList: [],
          workOrderTypeId: null,
          workNo: null,
          companyName: null,
          // title: null,
          exigency: null,
          beginTime: null,
          endTime: null,
          completionTimeBegin: null,
          completionTimeEnd: null,
          customer: null,
          operationDepartment: null,
          userId: null,
          status: this.closeType ? '5,7': '1,2,3,4,6,9'
        },
        tabIndex: '0',
        // 全部订单
        labelList1: [
          { label: this.$t('workOrderList.Urgent'), prop: 'exigency', isCheck: true, disabled: false,},
          { label: this.$t('billingPage.CustomerName'), prop: 'cusId', isCheck: true, disabled: false, width: '100' },
          { label: this.$t('AccountManagement.customer.companyName'), prop: 'companyName', isCheck: true, disabled: false, width: '100' },
          { label: this.$t('workOrderList.Number'), prop: 'workNo', isCheck: true, disabled: false,width: '200'},
          { label: this.$t('workOrderList.service'), prop: 'workOrderTypeName', isCheck: true, disabled: false,width:'115'},
          // { label: this.$t('workOrderList.title'), prop: 'title', isCheck: true, disabled: false,},
          { label: this.$t('workOrderList.Customer'), prop: 'customer', isCheck: true, disabled: false,},
          { label: this.$t('WorkorderType.table.InquiryType'), prop: 'consultType', isCheck: true, disabled: false,width: '100'},
          { label: this.$t('workOrderList.Operator'), prop: 'userName', isCheck: true, disabled: false,},
          { label: this.$t('workOrderList.state'), prop: 'status', isCheck: true, disabled: false,width: '160'},
          { label: this.$t('workOrderList.Creation'), prop: 'creationDate', isCheck: true, disabled: false,width: '125'},
          { label: this.$t('workOrderList.Review'), prop: 'auditTime', isCheck: true, disabled: false,width: '125'},
          { label: this.$t('workOrderList.timeS'), prop: 'scheduledStartTime', isCheck: true, disabled: false,width: '125'},
          { label: this.$t('workOrderList.timeE'), prop: 'scheduledEndTime', isCheck: true, disabled: false,width: '125'},
          { label: this.$t('workOrderList.Completion'), prop: 'completionTime', isCheck: true, disabled: false,width: '125'},
          { label: this.$t('table.operationText'), prop: 'bjTableAction', isCheck: true, disabled: false, width: '130' },
        ],
        customerNameList:[],
        // 部门下拉列表
        consultNameList:[],
        // 服务下拉列表
        workOrderTypeIdList:[],
        // 客服下拉列表
        customerNameList:[],
        // 操作部门下拉列表
        operationList:[],
        // 操作人下拉列表
        userIdNameList:[],
        pickerOptions: {
          // 限制时间选择今天及以后的
          disabledDate(time) {
            return time.getTime() < new Date().getTime() - 3600 * 1000 * 24;
          },
        },
      };
    },
    computed: {
      labelList() {
        return this.$store.getters.cusId ? this.labelList1.filter(item => item.prop != 'cusId') : this.labelList1;
      },
      exportLabelList() {
        const dateExport = { dateFormat: 'DD/MM/YYYY HH:mm' };
        return [
          { label: this.$t('workOrderList.Urgent'), prop: 'exigency', export: { options: CSG_WORK_ORDER_EXIGENCY, translate: true } },
          { label: this.$t('billingPage.CustomerName'), prop: 'cusId', export: { options: () => this.customerList } },
          { label: this.$t('workOrderList.Number'), prop: 'workNo' },
          { label: this.$t('workOrderList.service'), prop: 'workOrderTypeName' },
          { label: this.$t('workOrderList.Customer'), prop: 'customer' },
          { label: this.$t('workOrderList.Operations'), prop: 'operationDepartment' },
          { label: this.$t('workOrderList.Operator'), prop: 'userName' },
          { label: this.$t('workOrderList.state'), prop: 'status', export: { options: CSG_WORK_ORDER_STATUS_ADMIN, translate: true } },
          { label: this.$t('workOrderList.Creation'), prop: 'creationDate', export: dateExport },
          { label: this.$t('workOrderList.Review'), prop: 'auditTime', export: dateExport },
          { label: this.$t('workOrderList.timeS'), prop: 'scheduledStartTime', export: dateExport },
          { label: this.$t('workOrderList.timeE'), prop: 'scheduledEndTime', export: dateExport },
          { label: this.$t('workOrderList.Completion'), prop: 'completionTime', export: dateExport },
        ];
      },
      rules3() {
        const validateAuditTime = (rule, value, callback) => {
          this.$nextTick(() => {
            if (!this.form3.scheduledStartTime || !this.form3.scheduledEndTime) {
              callback(new Error(this.$t('chooseText')));
            }
            callback();
          });
        };

        return {
          auditTime: [{ required: true, validator: validateAuditTime, trigger: 'change' }],
        };
      },
    },
    watch: {
      queryParams_createTime(v) {
        this.queryParams.beginTime = (v || [])[0];
        this.queryParams.endTime = (v || [])[1];
      },
      queryParams_endTime(v) {
        this.queryParams.completionTimeBegin = (v || [])[0];
        this.queryParams.completionTimeEnd = (v || [])[1];
      },
      form3_endTime(v) {
        this.form3.scheduledStartTime = (v || [])[0];
        this.form3.scheduledEndTime = (v || [])[1];
      },
    },
    created(){
      // 获取部门下拉数据
      this.getWorkOrderConsultType()
      // 获取客服下拉框数据
      this.getCustomerList()
      // 获取操作部门下拉数据
      this.getDepartmentNameList()
      // 获取操作人下拉数据
      this.getUserIdList()
    },
    mounted() {
      this.$store.dispatch('values/getTags');
      this.$nextTick(()=>{
        if(this.$route.query.tabIndex){
          this.handleTabClick({name: String(this.$route.query.tabIndex)})
        }
      })
    },
    methods: {
      rowStyleFun({ row }) {
        const styleJson = {};
        if (row.isRed && [2,3,4].includes(Number(row.status))) {
          styleJson.color = 'red';
        }
        return styleJson;
      },
      // 获取客服下拉数据
      getCustomerList(){
        userApi.getUserList({enabled: true,customerType: 'P',deptAbbr:'Customer Service'}).then(res=>{
          this.customerNameList = res.content.map(item => {
            return { label: item.realName, value: item.realName };
          });
        })
      },
      // 获取操作部门下拉数据
      getDepartmentNameList(){
        userApi.getDepartmentList().then(res=>{
          this.operationList = res.map(item => {
            return { label: item.name, value: item.name };
          });
        })
      },
      // 获取操作人下拉数据
      getUserIdList(n,m){
        // this.queryParams.userId = null
        userApi.getUserList({
          enabled: true,
          belongTo: 1,
          customerType: 'P',
          size: 999,
          page: 0,
          pagesize: 999,
          currentPage: 0,
        }).then(res=>{
          this.userIdNameList = res.content.map(item => {
            return { label: item.realName, value: item.id };
          });
        })
      },
      // 获取部门下拉数据
      getWorkOrderConsultType(){
        workorderApi.getConsultationTypeList().then(res=>{
          this.consultNameList = res.content.map(item => {
            return { label: item.consultName, value: item.consultName };
          });
        })
      },
      // 获取服务下拉数据
      getNextList(n,m){
        this.queryParams.workOrderTypeId = null
        workorderApi.ordertypeList({
          consultName: n,
          prohibits: 1,
          currentPage: 0,
          page: 0,
          pagesize: 999,
          size: 999,
        }).then(res=>{
          this.workOrderTypeIdList = res.content.map(e=>{
              return {label : e.name,value : e.id}
          })
        })
      },
      // tab页点击事件
      handleTabClick(tab) {
        this.tabIndex = tab.name;
        this.queryParams_createTime = null;
        this.queryParams_endTime = null;
        this.queryParams={
          consultNameList: [],
          workOrderTypeId: null,
          workNo: null,
          title: null,
          beginTime: null,
          endTime: null,
          completionTimeBegin: null,
          completionTimeEnd: null,
          cusId: null,
          customer: null,
          operationDepartment: null,
        }
        if(this.closeType){
          if(tab.name == '0'){
            this.queryParams.status = '5,7'
          }else{
            this.queryParams.status = tab.name
          }
        }else{
          if(tab.name == '0'){
            this.queryParams.status = '1,2,3,4,6,9'
          }else{
            this.queryParams.status = tab.name
          }
        }
       
        setTimeout(() => { this.reFresh(); }, 500);
      },
      // 新增
      onAdd(){
        this.$router.push({
          name: 'BusinessWorkorderListForm',
          query: {type: 'add' },
        });
      },
      // 跳转详情
      onView(item) {
        this.$router.push({
          name: 'BusinessWorkorderListForm',
          query: { id: item.id,type: 'view' },
        });
      },
      command(text, row) {
        switch (text) {
            case 'edit':
                this.$router.push({
                  name: 'BusinessWorkorderListForm',
                  query: { id: row.id,type: 'edit' },
                });
                break;
            case 'delete':
                this.$confirm(this.$t('toast.deletionConfirmationText'), this.$t('toast.hintText'), {
                  confirmButtonText: this.$t('toast.okText'),
                  cancelButtonText: this.$t('toast.cancelText'),
                  type: 'warning',
                }).then(()=>{
                  this.delWorkOrder(row)
                })
                break;
            case 'submit':
                this.$confirm(this.$t('toast.operationText'), this.$t('toast.hintText'), {
                  confirmButtonText: this.$t('toast.okText'),
                  cancelButtonText: this.$t('toast.cancelText'),
                  type: 'warning',
                }).then(()=>{
                  this.submitWorkOrder(row)
                })
                break;
            case 'approval':
                this.$router.push({
                  name: 'BusinessWorkorderListForm',
                  query: { id: row.id,type: 'audit' },
                });
                break;
            case 'start':
                this.$confirm(this.$t('toast.operationText'), this.$t('toast.hintText'), {
                  confirmButtonText: this.$t('toast.okText'),
                  cancelButtonText: this.$t('toast.cancelText'),
                  type: 'warning',
                }).then(()=>{
                  this.startProcessWorkOrder(row)
                })
                break;
            case 'stop':
                this.$confirm(this.$t('toast.operationText'), this.$t('toast.hintText'), {
                  confirmButtonText: this.$t('toast.okText'),
                  cancelButtonText: this.$t('toast.cancelText'),
                  type: 'warning',
                }).then(()=>{
                  this.stopWorkOrder(row)
                })
                break;
            case 'completed':
                this.$router.push({
                  name: 'BusinessWorkorderListForm',
                  query: { id: row.id,type: 'completed' },
                });
                break;
            case 'invalid':
                this.$confirm(this.$t('toast.operationText'), this.$t('toast.hintText'), {
                  confirmButtonText: this.$t('toast.okText'),
                  cancelButtonText: this.$t('toast.cancelText'),
                  type: 'warning',
                }).then(()=>{
                  this.invalidWorkOrder(row)
                })
                break;
            case 'hoursDone':
                this.$router.push({
                  name: 'BusinessWorkorderListForm',
                  query: { id: row.id,type: 'hoursDone' },
                });
                break;
            case 'processor':
                this.upProcesso(row)
                break;
            case 'customerEdit':
                this.form2.id = row.id;
                this.form2.workNo = row.workNo;
                this.form2.customer = row.customer;
                this.addDialogVisibl2 = true
                break;
            case 'endTimeEdit':
                this.form3.id = row.id;
                this.form3.workNo = row.workNo;
                this.form3.scheduledStartTime = row.scheduledStartTime;
                this.form3.scheduledEndTime = row.scheduledEndTime;
                this.addDialogVisibl3 = true
                break;
            }
      },
      logSome(n,m){
        if(n){
          this.form.userId = n;
          this.form.userName = m.label;
        }
      },
      // 重新指派
      upProcesso(row){
        userApi.getUserList({enabled: true,customerType: 'P',deptAbbr:row.operationDepartment, size:999}).then(res=>{
          this.userRoleList = res.content.map(item => {
            return { label: item.realName, value: item.id };
          });
          this.form.id = row.id;
          this.form.workNo = row.workNo;
          this.form.userId = row.userId;
          this.form.userName = row.userName;
          this.addDialogVisible = true;
        })
      },
      submitForm(formName) {
        this.$refs[formName].validate(valid => {
          if (!valid) return this.$scrollToFormError();
          const POST_DATA = {
            id: this.form.id,
            workNo: this.form.workNo,
            userId: this.form.userId,
            userName: this.form.userName,
          }
          workorderApi.modifyDepWorkOrder(POST_DATA).then(res=>{
            if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
              this.$message.success(this.$t('toast.operationSuccessText'));
              this.addDialogVisible = false;
              this.$refs[formName].resetFields();
              this.reFresh();
            }
          })
        });
      },
      handleClose(formName) {
        this.addDialogVisible = false;
        this.addDialogVisibl2 = false;
        this.addDialogVisibl3 = false;
        this.form3_endTime = [];
        this.$refs[formName].resetFields();
      },
      // 删除
      delWorkOrder(row){
        workorderApi.deleteWorkOrder({id:row.id}).then(res=>{
          if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
            this.$message.success(this.$t('toast.operationSuccessText'));
            setTimeout(() => {
              this.reFresh();
            }, 500);
          }
        })
      },
      // 提交审核
      submitWorkOrder(row){
        workorderApi.startAuditWorkOrder({id:row.id}).then(res=>{
          if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
            this.$message.success(this.$t('toast.operationSuccessText'));
            setTimeout(() => {
              this.reFresh();
            }, 500);
          }
        })
      },
      // 开始处理
      startProcessWorkOrder(row){
        workorderApi.startProcessingWorkOrder({id:row.id}).then(res=>{
          if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
            this.$message.success(this.$t('toast.operationSuccessText'));
            setTimeout(() => {
              this.reFresh();
            }, 500);
          }
        })
      },
      // 暂停处理
      stopWorkOrder(row){
        workorderApi.stopWorkOrder({id:row.id}).then(res=>{
          if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
            this.$message.success(this.$t('toast.operationSuccessText'));
            setTimeout(() => {
              this.reFresh();
            }, 500);
          }
        })
      },
      // 作废
      invalidWorkOrder(row){
        workorderApi.invalidWorkOrder({id:row.id}).then(res=>{
          if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
            this.$message.success(this.$t('toast.operationSuccessText'));
            setTimeout(() => {
              this.reFresh();
            }, 500);
          }
        })
      },
      // 修改客服
      editWorkerCustomer(formName){
        this.$refs[formName].validate(valid => {
          if (!valid) return this.$scrollToFormError();
          const POST_DATA = {
            id: this.form2.id,
            workNo: this.form2.workNo,
            customer: this.form2.customer,
          }
          workorderApi.modifyDepWorkOrder(POST_DATA).then(res=>{
            if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
              this.$message.success(this.$t('toast.operationSuccessText'));
              this.addDialogVisibl2 = false;
              this.$refs[formName].resetFields();
              this.reFresh();
            }
          })
        });
      },
      // 修改 预计完成时间
      editWorkerEndTime(formName){
        this.$refs[formName].validate(valid => {
          if (!valid) return this.$scrollToFormError();
          const POST_DATA = {
            id: this.form3.id,
            workNo: this.form3.workNo,
            scheduledStartTime: this.form3.scheduledStartTime,
            scheduledEndTime: this.form3.scheduledEndTime,
          }
          workorderApi.modifyDepWorkOrder(POST_DATA).then(res=>{
            if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
              this.$message.success(this.$t('toast.operationSuccessText'));
              this.form3_endTime = [];
              this.addDialogVisibl3 = false;
              this.$refs[formName].resetFields();
              this.reFresh();
            }
          })
        });
      },
      /** 重置按钮操作 */
      beforeResetSearch() {
        this.queryParams_createTime = null;
        this.queryParams_endTime = null;
        return new Promise(resolve => {
          resolve();
        });
      },
      afterFetchOriginalData(res){
        const now = moment().day();
        const start = new Date();
        let deliveryTimeEnd;
        if([1,2].includes(now)){
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 4);
          deliveryTimeEnd = moment(start).format('YYYY-MM-DD HH:mm:ss')
        }else if([3,4,5].includes(now)){
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 2);
          deliveryTimeEnd = moment(start).format('YYYY-MM-DD HH:mm:ss')
        }else if([6].includes(now)){
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 2);
          deliveryTimeEnd = moment(start).format('YYYY-MM-DD 00:00:00')
        }else{
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 3);
          deliveryTimeEnd = moment(start).format('YYYY-MM-DD 00:00:00')
        }
        res.content.forEach(item => {
          item.isRed = moment(deliveryTimeEnd) > moment(item.scheduledEndTime)
        })
        this.$nextTick(() => {
          this.$refs.BjPage.tableData = res.content;
        });
      }
    },
  };
  </script>

  <style scoped>
  ::v-deep .bj-page .el-form-item__label{
    display: none;
  }
  </style>
